import { useCallback } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import { userMeStore, type UserMeStoreState } from './UserMeStore';
import { userMeDraftStore } from './UserMeDraftStore';
import { selectData } from '../selectors.ts';

import { useAttach } from '../useAttach';

export function useUserMeData() {
  useAttach(userMeStore, 'useUserMeData');
  return useStoreWithEqualityFn(userMeStore.store, selectData, shallow);
}
useUserMeData.store = userMeStore;

export function useUserMe() {
  useAttach(userMeStore, 'useUserMe');

  const draft = userMeDraftStore.store((state) => {
    return {
      userMe: state.userMe,
    };
  });

  const select = useCallback(
    (state: UserMeStoreState) => {
      return {
        userMe: draft.userMe ?? state.userMe,
        userMeInstance: state.data,
        isLoading: state.isLoading,
        error: state.error,
      };
    },
    [draft.userMe]
  );

  const result = useStoreWithEqualityFn(userMeStore.store, select, shallow);

  return result;
}
useUserMe.store = userMeStore;

export function useUserMeAttach() {
  useAttach(userMeStore, 'useUserMeAttach');
}
useUserMeAttach.store = userMeStore;
